import { useMatomo } from '@datapunt/matomo-tracker-react';
import { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

type SeoProps = {
  title?: string;
};

export const Seo: FC<SeoProps> = ({ title }) => {
  const { trackPageView } = useMatomo();
  const location = useLocation();
  const titleOnly = /\.[^.]*[.|:]/g.test(window.location.host);
  const metaTitle = title ? (titleOnly ? title : `${title} - SKEZI`) : 'SKEZI';

  useEffect(() => {
    trackPageView({
      documentTitle: metaTitle,
    });
    document.title = metaTitle;
  }, [location.pathname, metaTitle]);

  return null;
};
